import React from 'react';

import styles from './fileUploadListStyles';

import FileUploadListItem from './fileUploadListItem';

const FileUploadList = props => {
  const { files, deleteFile, changeName } = props;

  const handleDelete = idx => {
    return e => {
      e.preventDefault();
      deleteFile(idx);
    };
  };

  const handleNameChange = idx => {
    return e => {
      e.preventDefault();
      changeName(e.target.value, idx);
    };
  };

  return (
    <div className={styles.fileUploadListArea}>
      <table>
        <thead>
          <tr>
            <th className={styles.fileUploadHeader}>FILE</th>
            <th className={styles.fileUploadHeader}>NAME</th>
          </tr>
        </thead>
        <tbody>
          {files.map((fileData, idx) => (
            <FileUploadListItem
              key={`${fileData.file.name}-${idx}`}
              fileData={fileData}
              handleDelete={handleDelete(idx)}
              handleNameChange={handleNameChange(idx)}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default FileUploadList;
